// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__2hb4O","title-container":"style_title-container__1_v2r","title":"style_title__mBKhJ","graphs-container":"style_graphs-container__3RlWL"};